/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CMA
 */
export interface CMA {
    /**
     * 
     * @type {string}
     * @memberof CMA
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CMA
     */
    clientDisplayName?: string;
}

/**
 * Check if a given object implements the CMA interface.
 */
export function instanceOfCMA(value: object): value is CMA {
    return true;
}

export function CMAFromJSON(json: any): CMA {
    return CMAFromJSONTyped(json, false);
}

export function CMAFromJSONTyped(json: any, ignoreDiscriminator: boolean): CMA {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'clientDisplayName': json['clientDisplayName'] == null ? undefined : json['clientDisplayName'],
    };
}

export function CMAToJSON(json: any): CMA {
    return CMAToJSONTyped(json, false);
}

export function CMAToJSONTyped(value?: CMA | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'clientDisplayName': value['clientDisplayName'],
    };
}

